import { render, staticRenderFns } from "./GenericListComponent.vue?vue&type=template&id=987c2d3e&"
import script from "./GenericListComponent.vue?vue&type=script&lang=ts&"
export * from "./GenericListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports